export const SET_GROUPS = 'SET_GROUPS';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';

export const clearGroups = {
  type: CLEAR_GROUPS,
}

export const setGroups = (data) => {
  return {
    type: SET_GROUPS,
    payload: data,
  }
}